class SwatchSliderLite extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector('[data-swatch-container]');
    if (!container) return;

    const leftIndicator = container.previousElementSibling.previousElementSibling;
    const rightIndicator = container.previousElementSibling;

    this.container = container;
    this.leftIndicator = leftIndicator;
    this.rightIndicator = rightIndicator;

    const updateIndicators = () => {
      const hasOverflow = container.scrollWidth > container.clientWidth;
      const isAtStart = container.scrollLeft <= 10;
      const isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 10;

      // Handle visibility states
      const leftVisible = hasOverflow && !isAtStart;
      const rightVisible = hasOverflow && !isAtEnd;

      // Set display property
      leftIndicator.style.display = leftVisible ? 'block' : 'none';
      rightIndicator.style.display = rightVisible ? 'block' : 'none';

      // Set opacity for transitions (use requestAnimationFrame to allow display to take effect first)
      requestAnimationFrame(() => {
        leftIndicator.style.opacity = leftVisible ? '1' : '0';
        rightIndicator.style.opacity = rightVisible ? '1' : '0';
      });
    };

    this.updateIndicators = updateIndicators;

    this.handleRightClick = () => container.scrollBy({ left: window.innerWidth * 0.5, behavior: 'smooth' });

    this.handleLeftClick = () => container.scrollBy({ left: window.innerWidth * -0.5, behavior: 'smooth' });

    // Set up scroll handlers
    container.addEventListener('scroll', updateIndicators);
    rightIndicator.addEventListener('click', this.handleRightClick);
    leftIndicator.addEventListener('click', this.handleLeftClick);

    // Handle resize
    this.resizeObserver = new ResizeObserver(updateIndicators);
    this.resizeObserver.observe(container);

    // Initial check
    updateIndicators();
  }

  disconnectedCallback() {
    // Clean up event listeners and observers
    if (this.container) {
      this.container.removeEventListener('scroll', this.updateIndicators);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    if (this.rightIndicator) {
      this.rightIndicator.removeEventListener('click', this.handleRightClick);
    }

    if (this.leftIndicator) {
      this.leftIndicator.removeEventListener('click', this.handleLeftClick);
    }
  }
}

customElements.define('swatch-slider-lite', SwatchSliderLite);
